import ModelInterface from 'src/models/ModelInterface'
import {RawOrg} from '@/types/entity/RawOrg'
import store from '@/store/index'
import Vue from 'vue'

class Org extends ModelInterface<RawOrg> {

  constructor (data: RawOrg) {
    super(data)
  }

  public getName () {
    return this.data.name;
  }

  public getParentId () {
    return this.data.parent_id
  }

  public getAbbr () {
    return this.data.abbr;
  }

  public getContacts () {
    return this.data.contacts;
  }

  public getDescription () {
    return this.data.description
  }

  public getAddress () {
    return this.data.address
  }

  public getChief () {
    return this.data.chief || ''
  }

  public getChildren () {
    return this.data.children || []
  }

  public addChildren (child: Org) {
    if (!this.data.children) {
      Vue.set(this.data, 'children', [])
    }
    this.data.children!.push(child)
  }
}

export default Org
